import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, computed, nextTick, onMounted, toRefs } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';

import DKRichTextHtml from './DKRichTextHtml.vue';
import DKRichTextJson from './DKRichTextJson.vue';

type RichTextJson = { json: any };


export default /*#__PURE__*/_defineComponent({
  __name: 'DKRichText',
  props: {
    text: {},
    isAnimated: { type: Boolean, default: false },
    imageStack: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const { text, isAnimated } = toRefs(props);

const isVisible = ref(false);
const richTextRef = ref<HTMLDivElement>();

const isHTML = computed<boolean>(
  () => typeof text.value === 'string' && /<\/?[a-z][\s\S]*>/i.test(text.value)
);

const isJSON = computed<boolean>(
  () => typeof text.value === 'object' && text.value.json
);

const htmlText = computed<string | undefined>(() =>
  isHTML.value ? (text.value as string) : undefined
);

const json = computed<RichTextJson | undefined>(() =>
  isJSON.value ? (text.value as RichTextJson) : undefined
);

const visibleCondition = computed<boolean>(
  () => isVisible.value || !isAnimated.value
);

const intersect = (): void => {
  useIntersectionObserver(
    richTextRef.value,
    ([{ isIntersecting }]) => {
      if (isIntersecting) {
        isVisible.value = isIntersecting;
      }
    },
    { threshold: 0.25 }
  );
};

onMounted(() => {
  if (isAnimated.value) nextTick(intersect);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "richTextRef",
    ref: richTextRef,
    class: _normalizeClass(['dk-rich-text', { 'is-visible': visibleCondition.value }])
  }, [
    (!isJSON.value && !isHTML.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(text)), 1))
      : (isHTML.value && htmlText.value)
        ? (_openBlock(), _createBlock(DKRichTextHtml, {
            key: 1,
            html: htmlText.value
          }, null, 8, ["html"]))
        : (isJSON.value && json.value && visibleCondition.value)
          ? (_openBlock(), _createBlock(DKRichTextJson, {
              key: 2,
              json: json.value.json,
              "image-stack": _ctx.imageStack
            }, null, 8, ["json", "image-stack"]))
          : _createCommentVNode("", true)
  ], 2))
}
}

})